import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import {apiRoute} from "./_helpers/apiRoute";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: localStorage.getItem('token') || '',
        user: '',
        domain: apiRoute(),
        experience: '',
        education: '',
        user_type: localStorage.getItem('user_type') || '',
        about: '',
        skills:'',
        image:'',
        collegeId:'',
        refId:'',
        courses:'',
        companies:'',
        applicants:'',
        applications:'',
        candidates:'',
    },
    mutations: {
        save_user(state, payload) {
            state.user = payload;
        },
        user_setting(state, payload) {
            state.setting = payload;
        },
        auth_success(state, payload) {
            state.token = payload['access_token'];
            state.user = payload;
            state.user_type = payload['user_type']
            // state.isLoggedIn = true;
        },
        loggedOut: state => {
            delete localStorage.token;
            delete localStorage.source;
            delete localStorage.user_type;

            delete axios.defaults.headers.common['Authorization'];
            delete axios.defaults.headers.common['source'];
            // state.isLoggedIn = false;
            state.token = '';
        },
        add_experience: (state, payload) => {
            state.experience = payload;
        },
        add_collegeId: (state, payload) => {
            state.collegeId = payload;
        },
        add_refId: (state, payload) => {
            state.refId = payload;
        },
        add_education: (state, payload) => {
            state.education = payload;
        },
        add_about: (state, payload) => {
            state.about = payload;
        },
        add_image: (state, payload) => {
            state.image = payload;
        },
        add_skills: (state, payload) => {
            state.skills = payload;
        },
        add_courses: (state, payload) => {
            state.courses = payload;
        },
        see_companies: (state, payload) => {
            state.companies = payload;
        },
        see_applicants: (state, payload) => {
            state.applicants = payload;
        },
        see_applications: (state, payload) => {
            state.applications = payload;
        },
        see_candidates: (state, payload) => {
            state.candidates = payload;
        },
    },
    getters: {
        getAuthState: state => {
            if (state.token) {
                return true
            } else {
                return false
            }
        },
        getUser: state => {
            return state.user
        },
        getPreferences: state => {
            return state.setting
        },
        getDomain: state => {
            return state.domain
        },
        getToken: state => {
            return state.token
        },
        getExperience: state => {
            return state.experience
        },
        getUserType: state => {
            return state.user_type
        },
        getAbout: state => {
            return state.about
        },
        getImage: state => {
            return state.image
        },
        getCollegeId: state => {
            return state.collegeId
        },
        getRefId: state => {
            return state.refId
        },
        getSkills: state => {
            return state.skills
        },
        getExperienceById: (state) => (id) => {
            return state.experience.filter(function (num) {
                return num.id == id
            })
        },
        getEducation: state => {
            return state.education
        },
        getEducationById: (state) => (id) => {
            return state.education.filter(function (numE) {
                return numE.education_enc_id == id
            })
        },
        getCourses: state => {
            return state.courses
        },
        getCourseById: (state) => (id) => {
                return state.courses.filter(function (numC) {
                return numC.assigned_college_enc_id == id
            })
        },
        getCompanies: state => {
            return state.companies
        },
        getCompaniesById: (state) => (id) => {
            return state.companies.filter(function (numC) {
                return numC.organization_enc_id == id
            })
        },
        getApplicants: state => {
            return state.applicants
        },
        getApplicantsById: (state) => (id) => {
            return state.applicants.filter(function (numC) {
                return numC.loan_app_enc_id == id
            })
        },
        getApplications: state => {
            return state.applications
        },
        getApplicationsById: (state) => (id) => {
            return state.applications.filter(function (numC) {
                return numC.application_enc_id == id
            })
        },
        getCandidates: state => {
            return state.candidates
        },
        getCandidatesById: (state) => (id) => {
            return state.candidates.filter(function (numC) {
                return numC.user_enc_id == id
            })
        },
    },
    actions: {
        setLoggedIn: (context, payload) => {
            context.commit('auth_success', payload)
        },
        setLoggedOut: context => {
            context.commit('loggedOut')
        },
        saveExperience: (context, payload) => {
            context.commit('add_experience', payload)
        },
        saveEducation: (context, payload) => {
            context.commit('add_education', payload)
        },
        setUser: (context, payload) => {
            context.commit('save_user', payload)
        },
        setPreferences: (context, payload) => {
            context.commit('user_setting', payload)
        },
        setSkills: (context, payload) => {
            context.commit('add_skills', payload)
        },
        setAbout: (context, payload) => {
            context.commit('add_about', payload)
        },
        setImage: (context, payload) => {
            context.commit('add_image', payload)
        },
        setCollegeId: (context, payload) => {
            context.commit('add_collegeId', payload)
        },
        setRefId: (context, payload) => {
            context.commit('add_refId', payload)
        },
        setCourses: (context, payload) => {
            context.commit('add_courses', payload)
        },
        setCompanies: (context, payload) => {
            context.commit('see_companies', payload)
        },
        setApplicants: (context, payload) => {
            context.commit('see_applicants', payload)
        },
        setApplications: (context, payload) => {
            context.commit('see_applications', payload)
        },
        setCandidates: (context, payload) => {
            context.commit('see_candidates', payload)
        }
    }
})
